var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCoa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4218 11.8438H13.1438C12.8257 11.8438 12.5664 12.103 12.5664 12.421C12.5664 12.583 12.6352 12.7289 12.7426 12.8342L17.8675 17.9591C17.9727 18.0725 18.1248 18.1435 18.2909 18.1435C18.4914 18.1435 18.6676 18.0422 18.7709 17.8882C20.0309 16.4257 20.8412 14.5682 20.9871 12.5243C20.9952 12.4899 20.9992 12.4555 20.9992 12.421C20.9993 12.103 20.7419 11.8438 20.4218 11.8438Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9464 1.38086C10.6283 1.3828 10.3711 1.64014 10.3711 1.95815V10.0466C10.3711 10.3666 10.6283 10.6259 10.9464 10.6259H19.0369C19.3549 10.6259 19.6142 10.3666 19.6142 10.0466C19.3285 5.39171 15.6033 1.66652 10.9464 1.38086Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3929 17.488L9.4254 11.5205C9.32415 11.4171 9.26341 11.2733 9.26341 11.1173L9.26127 2.68857C9.26127 2.37056 9.00406 2.11328 8.68599 2.11328C3.83862 2.40906 0 6.43599 0 11.3564C0 16.4712 4.14659 20.6197 9.26127 20.6197C11.5948 20.6197 13.7258 19.7568 15.3544 18.3327C15.4801 18.2273 15.5591 18.0694 15.5591 17.8931C15.5591 17.7371 15.4962 17.5933 15.3929 17.488Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCoa);
export default __webpack_public_path__ + "static/media/UploadCOA.219f39896ea7bb024e23644830d97c80.svg";
export { ForwardRef as ReactComponent };